/* eslint-disable import/prefer-default-export */
import { LinkTextSize } from '~/components/Link/Link';
import { LoanAmountComponentTypes } from '~/components/LoanAmount/LoanAmount';
import { LoanPurposeComponentTypes } from '~/components/LoanPurpose/LoanPurpose';
import { Market, Language } from '~/sharedInterfaces/SharedEnums';
import { IAvailableSubmitTypes, IPage } from '~/sharedInterfaces/SharedInterfaces';

interface IAvailableWidgets {
  card: IPage[];
  loan: IPage[];
}

interface IDefaultPagesConfig {
  'no-no': IAvailableWidgets;
  'en-no': IAvailableWidgets;
}

const defaultPagesConfig: IDefaultPagesConfig = {
  'no-no': {
    loan: [
      {
        loanAmount: { componentType: LoanAmountComponentTypes.SLIDER },
        orgNumber: {},
        link: {
          textBefore: 'Qred behandler dine personopplysninger i henhold til GDPR og Qreds ',
          linkText: 'personvernerklæring.',
          linkUrl: 'https://www.qred.no/info/integritet',
          size: LinkTextSize.small,
        },
        next: { noSubmit: true },
      },
      {
        previous: { label: '<' },
        emailAddress: {},
        phoneNumber: {},
        termsAgreement: {},
        next: {},
      },
      {
        thankYouMessage: {},
        loanPurpose: { componentType: LoanPurposeComponentTypes.dropDown },
        personalNumber: {},
        documentUpload: {},
        next: {},
      },
    ],
    card: [
      {
        orgNumber: {},
        phoneNumber: {},
        emailAddress: {},
        termsAgreement: {},
        next: {},
      },
    ],
  },
  'en-no': {
    loan: [
      {
        loanAmount: { componentType: LoanAmountComponentTypes.SLIDER },
        orgNumber: {},
        link: {
          textBefore: 'Qred is processing your personal data in accordance with GDPR and its ',
          linkText: 'Privacy policy.',
          linkUrl: 'https://en.qred.no/info/integritet',
        },
        next: { noSubmit: true },
      },
      {
        previous: { label: '<' },
        emailAddress: {},
        phoneNumber: {},
        termsAgreement: {},
        next: {},
      },
      {
        thankYouMessage: {},
        loanPurpose: { componentType: LoanPurposeComponentTypes.dropDown },
        personalNumber: {},
        documentUpload: {},
        next: {},
      },
    ],
    card: [
      {
        orgNumber: {},
        phoneNumber: {},
        emailAddress: {},
        termsAgreement: {},
        next: {},
      },
    ],
  },
};

const noSpecifiedMarketConfig = {
  loan: [
    {
      loanAmount: {},
      loanTerm: {},
      orgNumber: {},
      phoneNumber: {},
      emailAddress: {},
      termsAgreement: {},
      next: {},
    },
  ],
  card: [
    {
      orgNumber: {},
      phoneNumber: {},
      emailAddress: {},
      termsAgreement: {},
      next: {},
    },
  ],
};

export const defaultPages = (
  market: Market,
  language: Language,
  widgetType: keyof IAvailableSubmitTypes
) => {
  const localeKey = `${language.toLowerCase()}-${market.toLowerCase()}` as keyof IDefaultPagesConfig;
  return (
    (defaultPagesConfig[localeKey] && defaultPagesConfig[localeKey][widgetType]) ||
    noSpecifiedMarketConfig[widgetType]
  );
  //   if (market === Market.Netherlands) {
  //     return {
  //       loan: [
  //         {
  //           loanAmount: {},
  //           loanTerm: {},
  //           orgNumber: {},
  //           homeAddress: {},
  //           phoneNumber: {},
  //           emailAddress: {},
  //           termsAgreement: {},
  //           next: {},
  //         },
  //       ],
  //       card: [
  //         {
  //           orgNumber: {},
  //           phoneNumber: {},
  //           homeAddress: {},
  //           emailAddress: {},
  //           termsAgreement: {},
  //           next: {},
  //         },
  //       ],
  //     };
  //   }
};
